import React from 'react';

import classnames from 'classnames';

import styles from './Modal.scss';

export default class Modal extends React.Component {
  render() {
    // Header
    const closeButton = <div className={styles.close} onClick={this.props.closePortal} />;
    const modalHeader = (
      <header className={styles.header}>
        <h1 className={styles.title}>{this.props.title}</h1>
        {this.props.headerClose ? closeButton : ''}
      </header>
    );

    // Footer
    const addClose = (elms) => {
      const elmList = Array.isArray(elms) ? elms : [React.cloneElement(elms, {key: 'footer-elm'})];

      return elmList.map((elm) => {
        if (elm.props.closeModal) {
          return React.cloneElement(elm, {clickAction: this.props.closePortal});
        } else {
          return elm;
        }
      }, this);
    };

    const modalFooter = this.props.modalFooter ? (
      <footer className={styles.footer}>
        {addClose(this.props.modalFooter)}
      </footer>
    ) : null;

    return (
      <div className={styles.wrapper}>
        <div
          className={classnames(styles.modal, this.props.className)}
          style={this.props.style}
        >
          {modalHeader}
          {this.props.children}
          {modalFooter}
        </div>

        <div className={styles.shade} />
      </div>
    );
  }
}

Modal.propTypes = {
  /** Additional styles get added here
  This is primarily for setting the width. Ex. {width: 500px} **/
  style: React.PropTypes.object,
  /** Function to remove the portal around the modal **/
  closePortal: React.PropTypes.func,
  /** For use when not being placed in a portal **/
  /** Does the header include the close X **/
  headerClose: React.PropTypes.bool,
  /** Header Title **/
  title: React.PropTypes.string,
  /** Modal content goes here **/
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node
  ]).isRequired,
  /** Modal footer content goes here **/
  modalFooter: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node
  ]),
  /** Allows buttons to close the modal **/
  className: React.PropTypes.string,

  // TODO: This is unused and likely a bug
  // eslint-disable-next-line react/no-unused-prop-types
  closeModal: React.PropTypes.bool,
};

Modal.defaultProps = {
  title: 'Modal Title',
  headerClose: true,
  className: '',
};



// WEBPACK FOOTER //
// ./src/components/modal/components/Modal.jsx